import React from "react";
import DivisionCmp from "../../../components/cards/DivisionCmp";
import { Grid } from "@mui/material";
import DocumentInfoComponent from "../../../components/detailInfo/documentInfoComponent";

import LoadDocumentCmp from "../../../components/thumbnail/loadDocumentCmp";
import IdntityCard from "./identity/idntityCard";
import { DocumentUrl } from "../../../models/loan.model";
import DivisionIdentityCmp from "../../../components/cards/divisionIdentityCmp";

interface SchemaInfoModel {
  data?: DocumentUrl[];
}
function _SellerIdentityInfo({ data }: SchemaInfoModel) {
  let nationalIdArray: any = [];
  let idArray: any = [];
  let nationalIdEnum = [
    {
      documentType: "SellerNationalCardFront",
      documentTypeTitle: " روی کارت ملی",
    },
    {
      documentType: "SellerNationalCardBack",
      documentTypeTitle: " پشت کارت ملی",
    },
  ];

  let idEnum = [
    {
      documentType: "SellerIdentityDocument_Page1",
      documentTypeTitle: " صفحه اول شناسنامه ",
    },
    {
      documentType: "SellerIdentityDocument_Page2",
      documentTypeTitle: "صفحه دوم شناسنامه ",
    },
    {
      documentType: "SellerIdentityDocument_PageDescription",
      documentTypeTitle: "صفحه توضیحات شناسنامه ",
    },
  ];
  let findednationalId: any;
  let findedId: any;
  if (data) {
    findednationalId = data.filter(
      (v) =>
        nationalIdEnum?.findIndex(
          (x: { documentType: String }) => x.documentType === v.documentType
        ) >= 0
    );
    findedId = data.filter(
      (v) =>
        idEnum?.findIndex(
          (x: { documentType: String }) => x.documentType === v.documentType
        ) >= 0
    );
  }
  return (
    <Grid container spacing={1}>
      <Grid
        container
        spacing={{ xs: 1, md: 2 }}
        columns={{ xs: 4, sm: 8, md: 12 }}
        className="gridDesignBirthCertificate"
        // className="gridDesignIdentity"
        xs={12}
        style={{ direction: "rtl" }}
      >
        {findednationalId?.length > 0 ? (
          <Grid item xs={6}>
            <IdntityCard
              title={"تصاویر کارت ملی"}
              iconAddress={"Images/BirthCertificate.svg"}
              data={findednationalId}
            />
          </Grid>
        ) : (
          ""
        )}
        {findedId?.length > 0 ? (
          <Grid item xs={6}>
            <IdntityCard
              title={"تصاویر شناسنامه"}
              iconAddress={"Images/NationalId.svg"}
              data={findedId}
            />
          </Grid>
        ) : (
          ""
        )}
      </Grid>
    </Grid>
  );
}
export default function SellerIdentityInfo({ data }: SchemaInfoModel) {
  const child = <_SellerIdentityInfo data={data} />;
  return <DivisionIdentityCmp child={child} />;
}
